<template>
  <v-layout row wrap>
    <v-flex xs12>
      <v-card>
        <v-card-title>
          <span class="title">Change</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text>
          <v-form @submit.prevent="formSubmit" ref="form">
            <v-container fluid grid-list-md>
              <v-layout row wrap>
                <v-flex xs12 md4>
                  <v-text-field v-model="admin.employee_id" label="Employee ID"
                                :error-messages="errors.collect('employee id')" v-validate="'required'"
                                data-vv-name="employee id" required></v-text-field>
                </v-flex>

                <v-flex xs12 md4>
                  <v-text-field v-model="admin.first_name" label="First name"
                                :error-messages="errors.collect('first name')" v-validate="'required'"
                                data-vv-name="first name" required></v-text-field>
                </v-flex>
                <v-flex xs12 md4>
                  <v-text-field v-model="admin.last_name" label="Last name"
                                :error-messages="errors.collect('last name')" v-validate="'required'"
                                data-vv-name="last name" required></v-text-field>
                </v-flex>

                <v-flex xs12 md6>
                  <v-text-field 
                    v-model="admin.email" label="E-mail"
                    :error-messages="errors.collect('email')" 
                    v-validate="'required|email'"
                    data-vv-name="email" 
                    required
                    hint="e.g. your.name@example.com"
                    persistent-hint></v-text-field>
                </v-flex>
                <v-flex xs12 md6>
                  <v-text-field 
                    v-model="admin.phone" 
                    label="Phone number"
                    :error-messages="errors.collect('phone number')" 
                    v-validate="'required|numeric'"
                    data-vv-name="phone number" 
                    required 
                    mask="+### ## ### ####"
                    hint="e.g. +855 10 123 4567"
                    persistent-hint></v-text-field>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    :items="getAllCompanies"
                    v-model="admin.company_code"
                    item-text="description"
                    item-value="company_code"
                    label="Company code"
                    multiple
                    chips
                    v-validate="'required'" 
                    :error-messages="errors.collect('company code')" 
                    data-vv-name="company code" 
                    hint="Assign this admin to one or more company code"
                    persistent-hint
                    required></v-select>
                </v-flex>
                <v-flex xs12>
                  <v-select
                    :items="getAllowedMenuItems"
                    v-model="menu"
                    item-text="title"
                    item-value="id"
                    label="Accessible menu"
                    multiple
                    chips
                    v-validate="'required'" 
                    :error-messages="errors.collect('accessible menu')" 
                    data-vv-name="accessible menu" 
                    hint="Assign this admin to one or more menu. <i>Dashboard</i> and <i>My profile</i> menu will be default to all user."
                    persistent-hint
                    required></v-select>
                </v-flex>
              </v-layout>
            </v-container>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-btn color="accent" @click="editAdminPasswordById(id)">change password</v-btn>
          <v-spacer></v-spacer>
          <v-btn @click="onFormSubmit()" dark color="accent" :loading="getLoading" :disable="getLoading">update
          </v-btn>
          <v-btn @click="clear()" color="secondary">clear</v-btn>
          <v-btn to="/admin">cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
    <v-snackbar :color="color" :timeout="timeout" bottom right v-model="snackbar">
      {{ text }}
      <v-btn flat dark @click.native="snackbar = false">
        <v-icon>clear</v-icon>
      </v-btn>
    </v-snackbar>
  </v-layout>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'change-admin',
  $_veeValidate: {
    validator: 'new'
  },
  data () {
    return {
      id: this.$route.params.id,
      admin: {},
      menu: [],
      loader: null,
      snackbar: false,
      y: 'top',
      mode: '',
      timeout: 5000,
      text: '',
      color: '',
      e2: true,
      e3: true
    }
  },
  computed: {
    ...mapGetters(['getLoading', 'getResponse', 'getAllCompanies', 'getAllowedMenuItems', 'getAccessibleMenu'])

  },
  methods: {
    ...mapActions(['changeAdminUser', 'fetchAllCompanies', 'setActiveAdmin', 'fetchMenuItems']),

    clear () {
      this.$refs.form.reset()
      this.$validator.reset()
    },

    onFormSubmit: function () {
      this.$validator.validateAll().then(result => {
        if (result) {
          let payload = {
            admin: this.admin,
            menu: this.menu
          }
          this.changeAdminUser(payload).then(() => {
            let response = this.getResponse
            this.snackbar = true
            this.text =
              response.status === 200
                ? 'Changed successfully.'
                : response.data.message
            this.color = response.status === 200 ? 'success' : 'error'
          })
        }
      })
    },

    editAdminPasswordById: function (id) {
      this.$router.push({ name: 'changeAdminPassword', params: { id: id } })
    }
  },
  mounted: function () {
    if (this.getAllCompanies.length === 0) {
      this.fetchAllCompanies()
    }

    if (this.getAllowedMenuItems.length === 0) {
      this.fetchMenuItems()
    }

    this.setActiveAdmin(this.id)
      .then(() => {
        this.admin = Object.assign({}, this.$store.state.admin.admin_user)
        this.menu = Object.assign([], this.getAccessibleMenu)
      })
      .catch(error => {
        console.log(error)
      })
  }
}
</script>

<style scoped>
.custom-loader {
  animation: loader 1s infinite;
  display: flex;
}

@-moz-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-webkit-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@-o-keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}

@keyframes loader {
  from {
    transform: rotate(0);
  }
  to {
    transform: rotate(360deg);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/admin-user/ChangeAdmin.vue